import styles from 'styles/layout/main.module.css';

export default function Main({ children }) {
  return <main>{children}</main>;
}
